/**
 * Fix for AJAX cart not updating immediately with EasyWholesale app
 * Bypasses analytics tracking errors and forces cart refresh
 */
(function() {
  'use strict';
  
  let cartRefreshTimeout;
  
  // Wait for DOM and jQuery to be ready
  function init() {
    // Handle standard theme add-to-cart
    document.documentElement.addEventListener('product:added', function(event) {
      console.log('Standard product added, forcing cart refresh...');
      scheduleCartRefresh(500);
    });
    
    // Handle EasyWholesale app add-to-cart button
    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('click', '.nm-wholesale-btn-add-to-cart', function() {
        console.log('Wholesale button clicked, will refresh cart...');
        scheduleCartRefresh(1000); // Longer delay for wholesale
      });
    }
    
    // Also listen for any fetch requests to cart/add.js
    interceptCartRequests();
  }
  
  // Schedule a cart refresh (debounced to prevent multiple rapid refreshes)
  function scheduleCartRefresh(delay) {
    clearTimeout(cartRefreshTimeout);
    cartRefreshTimeout = setTimeout(function() {
      console.log('Executing cart refresh...');
      forceCartRefresh();
    }, delay);
  }
  
  // Intercept fetch requests to detect cart additions
  function interceptCartRequests() {
    const originalFetch = window.fetch;
    window.fetch = function() {
      const url = arguments[0];
      
      // Check if this is a cart add request
      if (typeof url === 'string' && url.includes('/cart/add')) {
        console.log('Cart add request detected:', url);
        
        // Call original fetch
        return originalFetch.apply(this, arguments)
          .then(function(response) {
            // Clone response so we can still use it
            const clonedResponse = response.clone();
            
            // Schedule cart refresh after successful add
            if (response.ok) {
              console.log('Cart add successful, scheduling refresh...');
              scheduleCartRefresh(800);
            }
            
            return response;
          })
          .catch(function(error) {
            console.error('Cart add error:', error);
            // Still try to refresh in case item was added
            scheduleCartRefresh(1000);
            throw error;
          });
      }
      
      // Not a cart request, proceed normally
      return originalFetch.apply(this, arguments);
    };
  }
  
  // Force a hard cart refresh
  function forceCartRefresh() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart data fetched:', cart.item_count, 'items');
        
        // Trigger the theme's cart refresh event
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { 
            scrollToTop: false,
            cart: cart 
          }
        }));
        
        // Update cart count in header
        updateCartCount(cart.item_count);
        
        // Also update mini-cart if it exists
        updateMiniCart();
      })
      .catch(error => {
        console.error('Error refreshing cart:', error);
      });
  }
  
  // Update cart count bubble/indicator
  function updateCartCount(count) {
    const cartCountElements = document.querySelectorAll('[data-header-cart-count], .cart-count, .header__cart-count');
    cartCountElements.forEach(function(element) {
      element.textContent = count;
      if (count > 0) {
        element.classList.add('visible');
      }
    });
  }
  
  // Force mini-cart to re-render
  function updateMiniCart() {
    const miniCart = document.querySelector('[data-section-type="mini-cart"]');
    if (miniCart) {
      const sectionId = miniCart.getAttribute('data-section-id');
      if (sectionId) {
        fetch('/cart?section_id=' + sectionId)
          .then(response => response.text())
          .then(html => {
            console.log('Mini-cart updated');
          })
          .catch(error => {
            console.error('Error updating mini-cart:', error);
          });
      }
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
